import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

export const CurrenciesModelSchema = z
  .object({
    id: z.string(),
    code: z.string(),
    name: z.string(),
    symbol: z.string(),
    is_base: z.boolean()
  })
  .strict()

const CurrenciesModelFields = makeFieldKeys(CurrenciesModelSchema)

export type CurrenciesModel = z.infer<typeof CurrenciesModelSchema>

function validateCurrenciesModel(data: unknown): CurrenciesModel {
  try {
    return validateWithZodSchema(CurrenciesModelSchema, data, 'currencies model')
  } catch (error) {
    throw new Error(`Currencies model validation failed: ${error}`)
  }
}
